<template>
    <v-card @click.prevent="$emit('clickcard')" class="ma-1 mt-2 pa-0" :style="{backgroundColor: selectedTechnician != null && technician.username == selectedTechnician.username ? '#ffd700' : 'white'}">
        <v-card-text style="padding: 4px; " class="d-flex justify-space-between align-center tech" :class="{ excluded: technician.excluded}">
            <div style="font-size: 0.9em; font-weight: bold; text-wrap: nowrap; overflow: hidden;"
                class="d-flex- justify-space-between- align-center- flex-wrap- pl-2"
            >
                {{ technician.username }}
                <br/>
                {{ technician.firstName }} 
                <br/>
                {{ technician.lastName }}                
            </div> 
            <div class="mr-2"><v-icon @click="$emit('eject')" v-if="technician.excluded" large color="#ff5d5d">mdi-eject-circle-outline</v-icon><v-icon @click="$emit('eject')" v-else class="eject" large>mdi-eject-circle-outline</v-icon></div>
        </v-card-text>
        <!--<v-card-actions style="justify-content: space-evenly;">
            <v-btn x-small icon>
            <v-icon>mdi-share-variant</v-icon>
            34-34
            </v-btn>

            <v-btn x-small icon>
            <v-icon>mdi-wrench</v-icon>
            {{ sum_service_count }}
            </v-btn>

            <v-btn x-small icon style="text-transform: none;">
            <v-icon>mdi-timer-sand</v-icon>
            {{ sum_duration }}m
            </v-btn>            
        </v-card-actions>-->
    </v-card>
</template>
<script>
export default {
    props: {
        // Floating Button icon Color
        technician: {
            type: Object,
            default: null
        },
        selectedTechnician: {
            type: Object,
            default: null
        },
        avatar: {
            type: String,
            default: require('@/assets/images/avatars/004-bald.svg')
        },
        title: {
            type: String,
            default: 'Timothy Clarksons'
        },
        subTitle: {
            type: String,
            default: 'Vue Developer'
        },
        isFavorite: {
            type: Boolean,
            default: false
        },
        isVerified: {
            type: Boolean,
            default: false
        },
        ratingCount: {
            type: Number,
            default: 0
        },
        rating: {
            type: Number,
            default: 0
        },
        readmode: {
            type: Boolean,
            default: false
        }      
    },
    computed: {
        sum_duration() {
            return this.technician?.assignment?.map(x=>x.estimated_duration_mins).reduce((partialSum, a) => partialSum + a, 0) || 0;
        },
        sum_service_count() {
            return this.technician?.assignment?.map(x=>x.work_items.length).reduce((partialSum, a) => partialSum + a, 0) || 0;
        },
    },
    data() {
        return {
            help_rating: 4,
            favorite: this.isFavorite,  
            verified: this.isVerified,                      
        }
    }
}
</script>
<style lang="scss" scoped>
    .eject {
        visibility: hidden;
    }
    .tech:hover {
        .eject {
            visibility: visible;
        }
    }
    .excluded {
        border-inline-start: solid #ff5d5d;
    }
    .v-card:not(.v-card--text):not(.v-card--outlined):hover:before {
        opacity: 0!important;
    }
</style>
